if (!customElements.get('accordion-with-media')) {
  class AccordionWithMedia extends customElements.get('accordion-component') {
    constructor() {
      super();
    }

    handleButtonClick(e, button) {
      super.handleButtonClick(e, button);

      setTimeout(() => this.toggleActiveMedia());
    }

    toggleActiveMedia() {
      const openSection = this.querySelector(
        '[data-accordion-section].is-open',
      );
      const activeMedia = this.querySelector(
        '[data-accordion-media].is-active',
      );
      const newActiveMedia = this.querySelector(
        `[data-accordion-media][data-id="${openSection?.dataset.id}"]`,
      );

      if (!activeMedia || !newActiveMedia) return;

      activeMedia.classList.remove('is-active');
      newActiveMedia.classList.add('is-active');
    }
  }

  customElements.define('accordion-with-media', AccordionWithMedia);
}
